/**
 * MuiAccordionSummary
 */
const MuiAccordionSummary = {
  styleOverrides: {
    root: {
      height: 56
    }
  }
};
export default MuiAccordionSummary;